// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SdHNO","label":"styles_label__gU4o_"};